import * as exSelect from './';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLSelectElement {
        getValue(): string | string[];
        setValue(value: string | string[]): HTMLSelectElement;
        hasSelected(): boolean;
        getSelected(): string | string[];
        setSelected(value: any): HTMLSelectElement;
        setSelectedIndex(index: number): HTMLSelectElement;
        getOptions(): any[];
        addOptions(config?: Record<string, any>): HTMLSelectElement;
        removeOptions(find: any): HTMLSelectElement;
        resetOptions(config?: Record<string, any>): HTMLSelectElement;
    }
}

// ----------------------------------------------------------------------------

HTMLSelectElement.prototype.getValue = function (): string | string[] {
    return exSelect.getValue(this);
};

HTMLSelectElement.prototype.setValue = function (value: string | string[]): HTMLSelectElement {
    exSelect.setValue(this, value);

    return this;
};

// ----------------------------------------------------------------------------

HTMLSelectElement.prototype.hasSelected = function (): boolean {
    return exSelect.hasSelected(this);
};

HTMLSelectElement.prototype.getSelected = function (): string | string[] {
    return exSelect.getSelected(this);
};

HTMLSelectElement.prototype.setSelected = function (value: any): HTMLSelectElement {
    exSelect.setSelected(this, value);

    return this;
};

HTMLSelectElement.prototype.setSelectedIndex = function (index: number): HTMLSelectElement {
    exSelect.setSelectedIndex(this, index);

    return this;
};

// ----------------------------------------------------------------------------

HTMLSelectElement.prototype.addOptions = function (config?: Record<string, any>): HTMLSelectElement {
    exSelect.addOptions(this, config);

    return this;
};

HTMLSelectElement.prototype.removeOptions = function (find: any): HTMLSelectElement {
    exSelect.removeOptions(this, find);

    return this;
};

HTMLSelectElement.prototype.resetOptions = function (config?: Record<string, any>): HTMLSelectElement {
    exSelect.resetOptions(this, config);

    return this;
};
